import { render } from "./VerifyTransaction.vue?vue&type=template&id=976fe0e4"
import script from "./VerifyTransaction.vue?vue&type=script&lang=js"
export * from "./VerifyTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__